<template>
  <div v-if="!false" class="section full">
    <div class="inner">
      <div class="detail_book">
        <div class="eplist sbook">
          <div>
            <BaseSelfbook
              mode="view"
              :selfbook="getCurrentSelfBook"
              :color="getCurrentSelfBook.color"
              :status="getCurrentSelfBook.status"
              :title="getCurrentSelfBook.title"
            />
            <!-- TODO: @Tim: Switch to BaseButton later when refactoring -->
            <div class="preview_btn_wrap">
              <a target="_blank" class="an_a"
                ><span class="c_icon ico_view_sbook"></span
                ><span class="an_t">{{
                  $t('selfbook.selfbookdetailhead.1590')
                }}</span></a
              >
            </div>
          </div>
          <div>
            <!-- *********************** -->
            <!-- DISPLAY CURRENT DETAILS -->
            <!-- *********************** -->
            <div v-if="!showHeadEdit && $route.path !== '/selfbook/create'">
              <div class="info_wrap">
                <div class="row">
                  <p class="iconbox">
                    <!-- <span
                      class="meta_editer book"
                      :class="{ active: getCurrentSelfBook.hasPaper }"
                      ><span class="an_i"></span
                      ><span class="an_t">{{
                        $t('selfbook.selfbookdetailhead.book')
                      }}</span></span
                    > -->
                    <span
                      class="meta_editer epub"
                      :class="{ active: getCurrentSelfBook.hasEbook }"
                      ><span class="an_i"></span
                      ><span class="an_t">{{
                        $t('selfbook.selfbookdetailhead.ebook')
                      }}</span></span
                    >
                    <!-- <span
                      class="meta_editer pod"
                      :class="{ active: getCurrentSelfBook.hasPod }"
                      ><span class="an_i"></span
                      ><span class="an_t">{{
                        $t('selfbook.selfbookdetailhead.pod')
                      }}</span></span
                    > -->
                  </p>

                  <h3 class="meta_title">{{ getCurrentSelfBook.title }}</h3>
                  <p class="meta_author">{{ getCurrentSelfBook.author }}</p>
                  <p class="meta_publisher">
                    {{ getCurrentSelfBook.publisher }}
                  </p>
                  <p class="meta_date">{{ getCurrentSelfBook.date }}</p>

                  <p class="meta_rate">
                    <span class="score_wrap">
                      <p class="meta_rate">
                        <span class="score_wrap">
                          <span class="score_box">
                            <star-rating
                              :rating="getCurrentSelfBook.rating"
                              active-color="#FBE116"
                              :star-size="starSize"
                              :increment="increment"
                              :show-rating="showRating"
                              :read-only="readOnly"
                            />
                          </span>
                          <span class="score_score">{{
                            getCurrentSelfBook.rating
                          }}</span>
                          <span class="blind">{{
                            $t('common.ui.rating')
                          }}</span>
                          <span class="score_count_w">
                            (<span class="score_count">
                              {{ getCurrentSelfBook.reviewCount || 0 }} 명
                            </span>
                            ) <span class="blind"></span
                          ></span>
                        </span>
                      </p>
                    </span>
                  </p>
                </div>

                <div class="meta_detail">
                  <p class="meta_price">
                    <span class="blind">{{
                      $t('selfbook.selfbookdetailhead.4283')
                    }}</span>
                    <strong v-show="getCurrentSelfBook.price.ebook.listPrice">
                      <vue-intl-numberformat
                        locale="ko-KR"
                        class="price"
                        format-style="currency"
                        :currency="getCurrency.currency"
                        :number="getCurrentSelfBook.price.ebook.listPrice"
                      />

                      <strong
                        v-show="!getCurrentSelfBook.price.ebook.listPrice"
                      >
                        <vue-intl-numberformat
                          class="price"
                          locale="ko-KR"
                          format-style="currency"
                          :currency="getCurrency.currency"
                          number="0"
                        />
                      </strong>
                    </strong>
                    <!--
                    <span class="discount">
                      <span v-if="getCurrencySelfBook.price">
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="currency"
                          :currency="getCurrency.currency"
                          :number="getCurrencySelfBook.price"
                        />
                      </span>

                      <span v-if="!getCurrencySelfBook.price">
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="currency"
                          :currency="getCurrency.currency"
                          :number="0"
                        />
                      </span>
                      
                    -->
                    <!-- FIXME: Need confirmation as to when this discount is used -->
                    <!-- <span class="percent">
                      {{ $t('common.footer.7188') }}<span class="arrow">할인</span> )  </span -->
                  </p>
                </div>

                <!-- IF Selfbook has been relisted (재개) then show this message while selfbook.status = 'pending' -->

                <div
                  v-if="getCurrentSelfBook.status === 'pending'"
                  class="row mt20"
                >
                  <div class="guide_txt no_icon">
                    <p class="cr">
                      <span class="quarter_web">{{
                        $t('selfbook.selfbookdetailhead.1969')
                      }}</span>
                      <span class="quarter_mobile">{{
                        $t('selfbook.selfbookdetailhead.978')
                      }}</span>
                    </p>
                  </div>
                </div>

                <div
                  v-if="getCurrentSelfBook.status === 'adminStopped'"
                  class="row mt20 reason_wrap"
                >
                  <div class="guide_txt no_icon">
                    <p class="cr">
                      {{ $t('selfbook.selfbookdetailhead.790') }}
                    </p>
                    <div class="btn_wrap">
                      <button
                        type="button"
                        class="btn_open_reason"
                        @click="openReasonModal"
                      >
                        <span>{{
                          $t('selfbook.selfbookdetailhead.9561')
                        }}</span>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- SWITCH TO SELFBOOK METAINFO EDITING MODE -->
                <div
                  v-if="$route.path === '/selfbook/modify'"
                  class="btn_wrap atr"
                >
                  <a class="an_a" @click="editHead"
                    ><span class="c_icon ico_edit_sbook"></span
                    ><span class="an_t">{{
                      $t('selfbook.selfbookdetailhead.2682')
                    }}</span>
                  </a>
                </div>
              </div>

              <!-- IF selfbook.status = 'selling' Show the 판매 정지 button below -->
              <div v-if="getCurrentSelfBook.status === 'selling'">
                <div class="guide_txt no_icon quarter_web">
                  <p>{{ $t('selfbook.selfbookdetailhead.2614') }}</p>
                </div>
                <div class="bdsi_f0">
                  <a class="box_btn dull" @click="setStatusToStopped"
                    ><span class="an_t">{{
                      $t('selfbook.selfbookdetailhead.7006')
                    }}</span></a
                  >
                </div>
              </div>
            </div>

            <!-- Buttons shown when selfbook.status != 'selling' or 'pending' -->
            <div
              v-if="
                !showHeadEdit &&
                getCurrentSelfBook.status !== 'selling' &&
                getCurrentSelfBook.status !== 'pending' &&
                $route.path == '/selfbook/modify'
              "
              class="btn_wrap"
            >
              <!-- TODO: LIKELY TO BE A CONFIRM DELETE MODAL HERE, CURRENTLY NONE EXISTS FROM DESIGN/PUBLISHING. WAITING FOR DESIGN TEAM RESPONSE. -->
              <!--
              <div class="bdsi_f3">
                <a class="box_btn dull" @click="deleteSelfbook"
                  ><span class="an_t">{{ $t('selfbook.selfbookdetailhead.1661') }}</span></a
                >
              </div>
              <div class="bdsi_f3">
                <a class="box_btn" @click="relistSelfbook"
                  ><span class="an_t">{{ $t('selfbook.selfbookdetailhead.1363') }}</span></a
                >
              </div>
              <div class="bdsi_f3">
                <button
                  type="button"
                  class="box_btn"
                  @click="openConfirmEditModal"
                >
                  <span class="an_t">{{ $t('selfbook.selfbookdetailhead.5497') }}</span>
                </button>
              </div>
              -->
            </div>

            <!-- ***************** -->
            <!-- DISPLAY EDIT MODE -->
            <!-- ***************** -->
            <div
              v-if="showHeadEdit || $route.path == '/selfbook/create'"
              class="editer_form"
            >
              <div class="editer_text_wrap n_line">
                <input
                  id="modify-tile"
                  v-model="getCurrentSelfBook.title"
                  class="editer_input_t"
                  name="title"
                  :placeholder="$t('selfbook.selfbookdetailhead.6540')"
                />
              </div>

              <div class="editer_text_wrap n_line">
                <input
                  v-model="getCurrentSelfBook.author"
                  class="editer_input_t"
                  name="author"
                  style="width: 144px;"
                  :placeholder="$t('selfbook.selfbookdetailhead.9908')"
                />
                <span class="gap">/</span>
                <input
                  v-model="getCurrentSelfBook.publisher"
                  class="editer_input_t"
                  name="publisher"
                  style="width: 144px;"
                  :placeholder="$t('selfbook.selfbookdetailhead.9347')"
                />
              </div>

              <div class="editer_text_wrap n_line price_wrap">
                <div class="th">
                  <span>{{ $t('selfbook.selfbookdetailhead.1124') }}</span>
                </div>
                <div class="td">
                  <input
                    v-model="getCurrentSelfBook.price"
                    min="0"
                    class="editer_input_t"
                    name="price"
                    :title="$t('selfbook.selfbookdetailhead.6008')"
                    type="number"
                    :placeholder="$t('selfbook.selfbookdetailhead.6311')"
                    style="width: 120px;"
                    oninput="validity.valid || (value = '')"
                  />
                  <!-- Not sure why this is here. Needs confirmation -->
                  <!-- <span class="percent"
                        >{{ $t('selfbook.selfbookdetailhead.7145') }}<span class="arrow">할인</span></span
                      > -->
                  <div class="ar">
                    <!-- TODO: Price should be formatted in locale currency, when i18n is fully integrated -->
                    <span v-show="getCurrentSelfBook.price.ebook.listPrice">
                      <vue-intl-numberformat
                        class="price"
                        locale="ko-KR"
                        format-style="currency"
                        :currency="getCurrency.currency"
                        :number="getCurrentSelfBook.price.ebook.listPrice"
                      />
                    </span>

                    <span v-if="!getCurrentSelfBook.price.ebook.listPrice">
                      <vue-intl-numberformat
                        locale="ko-KR"
                        class="price"
                        format-style="currency"
                        :currency="getCurrency.currency"
                        number="0"
                      />
                    </span>
                  </div>
                  <div class="guide">
                    <p>{{ $t('selfbook.selfbookdetailhead.6040') }}</p>
                    <p>{{ $t('selfbook.selfbookdetailhead.2744') }}</p>
                  </div>
                </div>
              </div>

              <div
                v-if="!showHeadEdit && $route.path !== '/selfbook/create'"
                class="btn_wrap atr"
              >
                <a class="an_a" @click="editHead"
                  ><span class="c_icon ico_edit_sbook"></span
                  ><span class="an_t">{{
                    $t('selfbook.selfbookdetailhead.2708')
                  }}</span></a
                >
              </div>

              <!-- Selfbook.color selector -->
              <div class="editer_select_cover">
                <p>{{ $t('selfbook.selfbookdetailhead.2367') }}</p>
                <div class="text_label">
                  <label class="cursor"
                    ><input
                      v-model="getCurrentSelfBook.color"
                      type="radio"
                      name="select_cover"
                      class="chk_cover display-none"
                      value="blue"
                      checked
                    /><em></em
                    ><span class="blind">{{
                      $t('selfbook.selfbookdetailhead.blue')
                    }}</span></label
                  >
                  <label class="cursor"
                    ><input
                      v-model="getCurrentSelfBook.color"
                      type="radio"
                      name="select_cover"
                      class="chk_cover display-none"
                      value="orange"
                    /><em></em
                    ><span class="blind">{{
                      $t('selfbook.selfbookdetailhead.orange')
                    }}</span></label
                  >
                  <label class="cursor"
                    ><input
                      v-model="getCurrentSelfBook.color"
                      type="radio"
                      name="select_cover"
                      class="chk_cover display-none"
                      value="green"
                    /><em></em
                    ><span class="blind">{{
                      $t('selfbook.selfbookdetailhead.green')
                    }}</span></label
                  >
                </div>
              </div>
            </div>

            <!-- Buttons to save or cancel edits made -->
            <div v-if="showHeadEdit" class="btn_wrap ar">
              <div>
                <button class="box_btn dull" @click="editHead">
                  <span class="an_t">{{
                    $t('library.deletemodal.cancel')
                  }}</span>
                </button>
              </div>
              <div>
                <button class="box_btn" @click="saveHeadChanges">
                  <span class="an_t">{{ $t('library.deletemodal.save') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Removed this button because it doesn't make sense in the UI flow. Editor should only be accessible after saving the meta data for the file. Confirmed with 옥이사 -->
    <!-- <div class="btn_wrap">
                <div class="bdsi_f0">
                  <a href="javascript:void(0)" class="box_btn"
                    ><span class="an_t">{{ $t('selfbook.selfbookdetailhead.8102') }}</span></a
                  >
                </div>
              </div> -->

    <!-- MODAL TO DISPLAY REASON ADMIN STOPPED SALE OF THIS SELFBOOK -->
    <!--
    <transition name="modal-fade">
      <ReasonStoppedModal
        v-if="showReasonModal"
        :selfbook="selfbook"
        @close="closeReasonModal"
      />
    </transition>
    -->

    <!-- MODAL SHOWN BEFORE REPUBLISHING A SELFBOOK WITH STATUS 'stopped' -->
    <transition name="modal-fade">
      <ConfirmEditModal
        v-if="showConfirmEditModal"
        @close="closeConfirmEditModal"
      />
    </transition>
  </div>
</template>

<script>
import ConfirmEditModal from '@/components/selfbook/ConfirmEditModal.vue'
//import ReasonStoppedModal from '@/components/selfbook/ReasonStoppedModal.vue'
import BaseSelfbook from '@/components/base/BaseSelfbook.vue'
import StarRating from 'vue-star-rating'

import { mapGetters } from 'vuex'

export default {
  name: 'SelfbookDetailHead',

  components: {
    BaseSelfbook,
    //ReasonStoppedModal,
    ConfirmEditModal,
    StarRating
  },
  data() {
    return {
      showHeadEdit: false,
      showReasonModal: false,
      showConfirmEditModal: false,
      // For star-rating package
      starSize: 18,
      increment: 0.5,
      showRating: false,
      readOnly: true
    }
  },
  computed: {
    ...mapGetters(['getCurrentSelfBook', 'isSelfBookLoading', 'getCurrency'])
  },
  methods: {
    editHead() {
      this.showHeadEdit = !this.showHeadEdit
    },
    openReasonModal() {
      this.showReasonModal = true
    },
    closeReasonModal() {
      this.showReasonModal = false
    },
    openConfirmEditModal() {
      this.showConfirmEditModal = true
    },
    closeConfirmEditModal() {
      this.showConfirmEditModal = false
    },
    saveHeadChanges() {
      // ADD action to save updated selfbook details
    },
    deleteSelfbook() {
      // ADD action to delete selfbook
    },
    setStatusToStopped() {
      // ADD action to set selfbook.status to 'stopped'
    },
    relistSelfbook() {
      // ADD action to set selfbook.status = 'selling' with a timer of 5 days before the change takes effect (5 days is based on planning team decision)
    }
  }
}
</script>

<style lang="scss" scoped>
.score_score {
  margin-left: 8px;
}
</style>
